goog.provide('el8.appchart.dialog.order.util');


el8.appchart.dialog.order.util.validatePrescribingUser = function(order) {
    /**
     * Validate if a given order's prescribing user is valid before saving the order form.
     * When invalid, we let the user choose a prescribing user from practiceUsers.
     *
     * Invalid conditions include (in sequence):
     * 1. There is no prescribing user ID on the order e.g. staff ordering on behalf of provider
     * 2. The prescribing user is a staff
     * 3. Current user (provider and staff) is a delegate of multiple physicians
     * 4. Current user is a delegate but the prescribing user isn't one of the delegators
     *
     * @param {Object} order - The order to validate.
     * @return {boolean} - Whether the prescribing user is valid.
     */
    var currUser = el8.data.currUser;
    var prescribingUserId = order.getPrescribingUserId();
    if (!prescribingUserId) {
        return false;
    }

    var prescribingUser = el8.data.practiceUsers.getById(prescribingUserId);
    if (prescribingUser.isOfficeStaff()) {
        return false;
    }

    var delegatingPhysicianIds = currUser.getOrderDelegatingPhysicianIds();
    var isDelegateOfMultiplePhysicians = delegatingPhysicianIds.length > 1;
    var isPrescribingUserNotADelegator = delegatingPhysicianIds.length && !_.contains(delegatingPhysicianIds, prescribingUser.getStaffId());

    if (isDelegateOfMultiplePhysicians) {
        return false;
    }
    if (isPrescribingUserNotADelegator) {
        return false;
    }

    return true;
};
